import { Promise } from 'bluebird';

export const LocalImageNames = [
  'consultant.jpg',
  'attorney.jpg',
  'car_dealer.jpg',
  'design_agency.jpg',
  'estate_appraiser.jpg',
  'family_doctor.jpg',
  'food.jpg',
];

const attorney = require('./local-images/attorney.jpg');
const consultant = require('./local-images/consultant.jpg');
const carDealer = require('./local-images/car_dealer.jpg');
const designAgency = require('./local-images/design_agency.jpg');
const estateAppraiser = require('./local-images/estate_appraiser.jpg');
const familyDoctor = require('./local-images/family_doctor.jpg');
const food = require('./local-images/food.jpg');

const mobileAttorney = require('./mobile-local-images/attorney.jpg');
const mobileConsultant = require('./mobile-local-images/consultant.jpg');
const mobileCarDealer = require('./mobile-local-images/car_dealer.jpg');
const mobileDesignAgency = require('./mobile-local-images/design_agency.jpg');
const mobileEstateAppraiser = require('./mobile-local-images/estate_appraiser.jpg');
const mobileFamilyDoctor = require('./mobile-local-images/family_doctor.jpg');
const mobileFood = require('./mobile-local-images/food.jpg');

const localImageSrcs = {
  attorney,
  consultant,
  car_dealer: carDealer,
  design_agency: designAgency,
  estate_appraiser: estateAppraiser,
  family_doctor: familyDoctor,
  food,

  mobile_attorney: mobileAttorney,
  mobile_consultant: mobileConsultant,
  mobile_car_dealer: mobileCarDealer,
  mobile_design_agency: mobileDesignAgency,
  mobile_estate_appraiser: mobileEstateAppraiser,
  mobile_family_doctor: mobileFamilyDoctor,
  mobile_food: mobileFood,
};

export const DefaultLocalImageName = LocalImageNames[0];

export const loadLocalImage = (imageName, isMobile = false) => {
  const name = imageName.split('.')[0];

  const prefix = isMobile ? 'mobile_' : '';
  return Promise.resolve(localImageSrcs[`${prefix}${name}`]);
};
